
<div>
  <h4>Categories and Shift validation</h4>
  <p>Here you can enable the visibility of categories/ types for the board.</p>
  <p>
    Additionally you can enable validation for the board and choose which Task Types should be included in Shift
    <br />
    validation. When the shift is validated, for each task type which was not used during the shift, a reminder task will be created.
  </p>
  <p>
    The checkbox "relevant for shift report" controls which tasks will be automatically included in the relevant items of the shift
    report.
  </p>
  <div class="validation mt-4" @change="isDirty = true">
    <div class="row" v-if="settings.enableShifts">
      <div class="col-12">
        <div class="label">Enable Shift Validation</div>
        <checkbox-with-label
          :label="'Enable Shift Validation'"
          v-model="settings.isValidationEnabled"
          @input="() => (isDirty = true)"
        ></checkbox-with-label>
      </div>
    </div>

    <div class="mt-4">
      <div class="label">Relevant Task Types</div>
      <div class="container-fluid">
        <div class="row">
          <div class="types-box col-12">
            <div class="row pt-2 mb-2">
              <div class="col-6">
                <label class="font-weight-bold">Category/Type</label>
              </div>
              <div class="col-2">
                <label class="font-weight-bold">Available</label>
              </div>
              <div class="col-2" v-if="settings.enableShifts">
                <label class="font-weight-bold">Relevant for shift validation</label>
              </div>
              <div class="col-2" v-if="settings.enableShifts">
                <label class="font-weight-bold">Relevant for shift report</label>
              </div>
            </div>
            <div class="row">
              <div class="col-2 offset-6">
                <checkbox-with-label
                  :label="selectAllAvailable ? 'Unselect all' : 'Select all'"
                  v-model="selectAllAvailable"
                  @input="setAvailableStateForAll"
                ></checkbox-with-label>
              </div>

              <div class="col-2" v-if="settings.enableShifts">
                <checkbox-with-label
                  :label="selectAllRelevant ? 'Unselect all' : 'Select all'"
                  v-model="selectAllRelevant"
                  @input="setRelevantStateForAll"
                  :disabled="!settings.isValidationEnabled"
                ></checkbox-with-label>
              </div>
              <div class="col-2" v-if="settings.enableShifts">
                <checkbox-with-label
                  :label="selectAllRelevant ? 'Unselect all' : 'Select all'"
                  v-model="selectAllRelevant"
                  @input="setRelevantForShiftReportStateForAll"
                ></checkbox-with-label>
              </div>
            </div>
            <div class="row" v-for="cat in categories" :key="cat.id">
              <div class="col-12">
                <div>
                  <h6 class="font-weight-bold">{{ cat.text }}</h6>
                </div>
                <div class="row" v-for="type in cat.items" :key="type.typeId">
                  <div class="col-6">
                    <label class="ml-3">
                      {{ type.text }}
                    </label>
                  </div>
                  <div class="col-2">
                    <checkbox-with-label
                      :label="'Available'"
                      v-model="type.isAvailable"
                      @input="() => processAvailableChanges(type)"
                    ></checkbox-with-label>
                  </div>
                  <div class="col-2">
                    <checkbox-with-label
                      :label="'Relevant'"
                      v-model="type.isRelevant"
                      @input="processRelevantChanges(type)"
                      :disabled="!settings.isValidationEnabled"
                    ></checkbox-with-label>
                  </div>

                  <div class="col-2">
                    <checkbox-with-label
                      :label="'Relevant'"
                      v-model="type.isRelevantForShiftReport"
                      @input="processRelevantForShiftReportChanges()"
                    ></checkbox-with-label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div class="d-flex justify-content-end">
        <button :disabled="!isDirty" class="btn btn-save btn-sm btn-success" @click="save">
          <i class="far fa-save"></i>
          Save changes
        </button>
      </div>
    </div>
  </div>
</div>
